const phoneNumbers=[
{countryCode: "af",length:"14"},
{countryCode: "al",length:"15"},
{countryCode: "dz",length:"15"},
{countryCode: "as",length:"16"},
{countryCode: "ad",length:"15"},
{countryCode: "ao",length:"15"},
{countryCode: "ai",length:"16"},
{countryCode: "ag",length:"16"},
{countryCode: "ar",length:"12"},
{countryCode: "am",length:"15"},
{countryCode: "aw",length:"15"},
{countryCode: "au",length:"11"},
{countryCode: "at",length:"15"},
{countryCode: "az",length:"16"},
{countryCode: "bs",length:"17"},
{countryCode: "bh",length:"15"},
{countryCode: "bd",length:"16"},
{countryCode: "by",length:"12"},
{countryCode: "bb",length:"15"},
{countryCode: "by",length:"12"},
{countryCode: "be",length:"11"},
{countryCode: "bz",length:"15"},
{countryCode: "bj",length:"15"},
{countryCode: "bm",length:"16"},
{countryCode: "bt",length:"15"},
{countryCode: "bo",length:"15"},
{countryCode: "ba",length:"15"},
{countryCode: "bw",length:"15"},
{countryCode: "br",length:"13"},
{countryCode: "ba",length:"15"},
{countryCode: "bw",length:"15"},
{countryCode: "br",length:"13"},
{countryCode: "io",length:"15"},
{countryCode: "vg",length:"16"},
{countryCode: "bn",length:"15"},
{countryCode: "bg",length:"15"},
{countryCode: "bf",length:"15"},
{countryCode: "bi",length:"15"},
{countryCode: "kh",length:"15"},
{countryCode: "cm",length:"15"},
{countryCode: "ca",length:"11"},
{countryCode: "cv",length:"15"},
{countryCode: "bq",length:"15"},
{countryCode: "ky",length:"16"},
{countryCode: "cf",length:"15"},
{countryCode: "td",length:"15"},
{countryCode: "cl",length:"15"},
{countryCode: "cn",length:"13"},
{countryCode: "co",length:"15"},
{countryCode: "km",length:"16"},
{countryCode: "cd",length:"16"},
{countryCode: "cg",length:"16"},
{countryCode: "ck",length:"16"},
{countryCode: "cr",length:"11"},
{countryCode: "ci",length:"15"},
{countryCode: "hr",length:"15"},
{countryCode: "cu",length:"15"},
{countryCode: "cw",length:"16"},
{countryCode: "cy",length:"11"},
{countryCode: "cz",length:"15"},
{countryCode: "dk",length:"10"},
{countryCode: "dj",length:"15"},
{countryCode: "dm",length:"16"},
{countryCode: "do",length:"15"},
{countryCode: "ec",length:"17"},
{countryCode: "eg",length:"16"},
{countryCode: "sv",length:"11"},
{countryCode: "gq",length:"15"},
{countryCode: "er",length:"15"},
{countryCode: "ee",length:"13"},
{countryCode: "et",length:"15"},
{countryCode: "fk",length:"15"},
{countryCode: "fo",length:"15"},
{countryCode: "fj",length:"15"},
{countryCode: "fi",length:"12"},
{countryCode: "fr",length:"11"},
{countryCode: "gf",length:"15"},
{countryCode: "pf",length:"15"},
{countryCode: "ga",length:"15"},
{countryCode: "gm",length:"15"},
{countryCode: "ge",length:"15"},
{countryCode: "de",length:"14"},
{countryCode: "gh",length:"15"},
{countryCode: "gi",length:"15"},
{countryCode: "gr",length:"15"},
{countryCode: "gl",length:"16"},
{countryCode: "gd",length:"17"},
{countryCode: "gp",length:"16"},
{countryCode: "gu",length:"17"},
{countryCode: "gt",length:"11"},
{countryCode: "gn",length:"15"},
{countryCode: "gw",length:"15"},
{countryCode: "gy",length:"15"},
{countryCode: "ht",length:"11"},
{countryCode: "hn",length:"15"},
{countryCode: "hk",length:"11"},
{countryCode: "hu",length:"15"},
{countryCode: "is",length:"10"},
{countryCode: "in",length:"12"},
{countryCode: "id",length:"15"},
{countryCode: "ir",length:"15"},
{countryCode: "iq",length:"16"},
{countryCode: "ie",length:"12"},
{countryCode: "il",length:"13"},
{countryCode: "it",length:"12"},
{countryCode: "jm",length:"15"},
{countryCode: "jp",length:"12"},
{countryCode: "jo",length:"15"},
{countryCode: "kz",length:"11"},
{countryCode: "ke",length:"15"},
{countryCode: "ki",length:"15"},
{countryCode: "xk",length:"15"},
{countryCode: "kw",length:"15"},
{countryCode: "kg",length:"15"},
{countryCode: "la",length:"15"},
{countryCode: "lv",length:"15"},
{countryCode: "lb",length:"15"},
{countryCode: "ls",length:"15"},
{countryCode: "lr",length:"15"},
{countryCode: "ly",length:"15"},
{countryCode: "li",length:"15"},
{countryCode: "lt",length:"15"},
{countryCode: "lu",length:"15"},
{countryCode: "mo",length:"15"},
{countryCode: "mk",length:"15"},
{countryCode: "mg",length:"15"},
{countryCode: "mw",length:"15"},
{countryCode: "my",length:"12"},
{countryCode: "mv",length:"15"},
{countryCode: "ml",length:"15"},
{countryCode: "mt",length:"15"},
{countryCode: "mh",length:"15"},
{countryCode: "mq",length:"15"},
{countryCode: "mr",length:"15"},
{countryCode: "mu",length:"15"},
{countryCode: "mx",length:"15"},
{countryCode: "fm",length:"16"},
{countryCode: "md",length:"11"},
{countryCode: "mc",length:"15"},
{countryCode: "mn",length:"15"},
{countryCode: "me",length:"15"},
{countryCode: "ms",length:"16"},
{countryCode: "ma",length:"15"},
{countryCode: "mz",length:"15"},
{countryCode: "mm",length:"15"},
{countryCode: "na",length:"16"},
{countryCode: "nr",length:"16"},
{countryCode: "np",length:"16"},
{countryCode: "nl",length:"12"},
{countryCode: "nc",length:"15"},
{countryCode: "nz",length:"12"},
{countryCode: "ni",length:"15"},
{countryCode: "ne",length:"15"},
{countryCode: "ng",length:"15"},
{countryCode: "nu",length:"15"},
{countryCode: "nf",length:"15"},
{countryCode: "kp",length:"15"},
{countryCode: "mp",length:"16"},
{countryCode: "no",length:"10"},
{countryCode: "om",length:"15"},
{countryCode: "pk",length:"12"},
{countryCode: "pw",length:"15"},
{countryCode: "ps",length:"15"},
{countryCode: "pa",length:"15"},
{countryCode: "pg",length:"15"},
{countryCode: "py",length:"15"},
{countryCode: "pe",length:"15"},
{countryCode: "ph",length:"13"},
{countryCode: "pl",length:"11"},
{countryCode: "pt",length:"15"},
{countryCode: "pr",length:"15"},
{countryCode: "qa",length:"17"},
{countryCode: "re",length:"17"},
{countryCode: "ro",length:"16"},
{countryCode: "ru",length:"11"},
{countryCode: "rw",length:"15"},
{countryCode: "bl",length:"15"},
{countryCode: "sh",length:"15"},
{countryCode: "kn",length:"16"},
{countryCode: "lc",length:"16"},
{countryCode: "mf",length:"15"},
{countryCode: "pm",length:"15"},
{countryCode: "vc",length:"16"},
{countryCode: "ws",length:"15"},
{countryCode: "sm",length:"15"},
{countryCode: "st",length:"15"},
{countryCode: "sa",length:"15"},
{countryCode: "sn",length:"15"},
{countryCode: "rs",length:"15"},
{countryCode: "sc",length:"15"},
{countryCode: "sl",length:"15"},
{countryCode: "sg",length:"10"},
{countryCode: "sx",length:"15"},
{countryCode: "sk",length:"15"},
{countryCode: "si",length:"15"},
{countryCode: "sb",length:"15"},
{countryCode: "so",length:"15"},
{countryCode: "za",length:"15"},
{countryCode: "kr",length:"13"},
{countryCode: "ss",length:"15"},
{countryCode: "es",length:"11"},
{countryCode: "lk",length:"15"},
{countryCode: "sd",length:"16"},
{countryCode: "sr",length:"16"},
{countryCode: "sz",length:"16"},
{countryCode: "se",length:"11"},
{countryCode: "ch",length:"11"},
{countryCode: "sy",length:"15"},
{countryCode: "tw",length:"15"},
{countryCode: "tj",length:"15"},
{countryCode: "tz",length:"15"},
{countryCode: "th",length:"15"},
{countryCode: "tl",length:"16"},
{countryCode: "tg",length:"16"},
{countryCode: "tk",length:"16"},
{countryCode: "to",length:"16"},
{countryCode: "tt",length:"17"},
{countryCode: "tn",length:"16"},
{countryCode: "tr",length:"12"},
{countryCode: "tm",length:"15"},
{countryCode: "tc",length:"16"},
{countryCode: "tv",length:"15"},
{countryCode: "vi",length:"16"},
{countryCode: "ug",length:"15"},
{countryCode: "ua",length:"12"},
{countryCode: "ae",length:"15"},
{countryCode: "gb",length:"12"},
{countryCode: "us",length:"11"},
{countryCode: "uy",length:"15"},
{countryCode: "uz",length:"15"},
{countryCode: "vu",length:"15"},
{countryCode: "va",length:"12"},
{countryCode: "ve",length:"15"},
{countryCode: "vn",length:"15"},
{countryCode: "wf",length:"16"},
{countryCode: "ye",length:"16"},
{countryCode: "al",length:"20"},
{countryCode: "al",length:"20"},
{countryCode: "al",length:"20"},
{countryCode: "al",length:"20"},
{countryCode: "al",length:"20"},
{countryCode: "al",length:"20"},
{countryCode: "al",length:"20"},
{countryCode: "al",length:"20"},
{countryCode: "al",length:"20"},
{countryCode: "al",length:"20"},
{countryCode: "al",length:"20"},
{countryCode: "al",length:"20"},
{countryCode: "al",length:"20"},
{countryCode: "al",length:"20"},
{countryCode: "al",length:"20"}

]

export default phoneNumbers;